import { dispatch, req } from "hf-rt";
import { HOST_URL } from "../constants";
import { lockBody, unlockBody } from "../function/bodyLockStatus";

const initialState = {
  wishListItems: null,
  getWishListSuccessfully: false,
  wishListModalOpen: false
};

export default {
  name: "myFav",
  actions: {
    updateMyFav: (payload, getSuccessfully = false) =>
      dispatch({ type: "UPDATE_MYFAV", payload, getSuccessfully }),
    fetchMyFavList: async function () {
      dispatch({ type: "FETCH_MYFAV_LIST" });
      try {
        const response = await fetch(
          `${HOST_URL}/shopping/v1/compositions/wishList`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            },
            credentials: "include"
          }
        );
        if (response.status === 200) {
          const data = await response.json();
          const getSuccessfully = true;
          this.updateMyFav(data, getSuccessfully);
        } else {
          this.updateMyFav(null);
          window.logApiErrors(
            "r",
            "fetchMyFavList",
            response.status,
            response.statusText
          );
          throw new Error(response.status);
        }
      } catch (error) {
        console.log("錯誤", error);
      }
    },
    removeFromMyFav: async function (wishItemCode) {
      dispatch({ type: "REMOVE_FROM_MYFAV" });
      // await req.delete({
      //   api: "wishListItems",
      //   params: pdtId
      // });
      try {
        const response = await fetch(
          `${HOST_URL}/shopping/v1/wishListItems/${wishItemCode}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json"
            },
            credentials: "include"
          }
        );
        if (response.status === 204) {
          this.fetchMyFavList();
          // POST MESSAGE 給 Header 去更新Wish List
          window.postMessage("UPDATE_WISHLIST", "*");
        } else {
          window.logApiErrors(
            "r",
            "removeFromMyFav",
            response.status,
            response.statusText
          );
          throw new Error(response.status);
        }
      } catch (error) {
        console.log(error);
      } finally {
      }
    },
    addToMyFav: async function (data) {
      dispatch({ type: "ADD_TO_MYFAV" });
      // await req.post({
      //   api: "wishListItems",
      //   body: pdtId
      // });
      try {
        const response = await fetch(`${HOST_URL}/shopping/v1/wishListItems`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include",
          body: JSON.stringify(data)
        });
        if (response.ok) {
          this.fetchMyFavList();
          // POST MESSAGE 給 Header 去更新Wish List
          window.postMessage("UPDATE_WISHLIST", "*");
        } else {
          window.logApiErrors(
            "r",
            "addToMyFav",
            response.status,
            response.statusText
          );
          throw new Error(response.status);
        }
      } catch (error) {
        console.log(error);
      } finally {
      }
    },
    showWishListModal: function(bool) {
      if (bool) {
        lockBody();
        } else {
        unlockBody();
      }
      dispatch({ type: "SHOW_WISHLIST_MODAL", bool });
          }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "UPDATE_MYFAV":
        return {
          ...state,
          wishListItems: action.payload,
          getWishListSuccessfully: action.getSuccessfully
        };
      case "SHOW_WISHLIST_MODAL":
        return {
          ...state,
          wishListModalOpen: action.bool
        };
      default:
        return state;
    }
  }
};
